import React from 'react';
import { ToastContainer, toast } from 'react-toastify'

import Presenter from '../../../../user/model/presenter.js'
import RequestProperties from '../../../../user/model/helper/request.props.js'
import '../../../assets/pages/css/login-4.css';

export default class ForgotScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nick     : '',
      disabled : true,
      process  : false,
    }

    this.onEnter   = this.onEnter.bind(this)
    this.change    = this.change.bind(this)
    this.gotoLogin = this.gotoLogin.bind(this)

    this.onSend        = this.onSend.bind(this)
    this.onSendSuccess = this.onSendSuccess.bind(this)
    this.onSendFailed  = this.onSendFailed.bind(this)
  }

  gotoLogin() {
    this.props.history.push('/login')
  }

  onSend() {
    const {nick} = this.state 

    if(nick.trim() !== "") {
      this.setState({
        process : true
      })

      Presenter.Forgot(
        RequestProperties.Forgot(nick, this.onSendSuccess, this.onSendFailed)
      )
    }

  } 

  onSendSuccess(params, response) {
    toast.success("we send the password reset link to the email address " + response.data.Result)
    this.setState({
      process : false,
      nick    : "",
      disabled:true,
    })
  }

  onSendFailed(response) {
    try {
      toast.error(response.data.non_field_errors[0])
      
      this.setState({
        process : false,
        nick    : "",
        disabled:true,
      })
    }
    catch(error) {
      console.error("error connect to server");
    }
  }

  onEnter(e) {
    if(e.key === 'Enter') {
      this.onSend()
    }
  }

  change(e) {
    let value = e.target.value
    let disabled = true, new_state

    if(value.trim() !== "") {
      disabled = false
    }

    new_state = {
      disabled: disabled,
      nick : value,
    }

    this.setState(new_state)
  }

  renderButton() {
    const {process} = this.state

    if(process) {
      return <button type="button" className="btn btn-primary px-4" disabled><i className='fa fa-spinner fa-pulse fa-fw'></i></button>
    }else {
      return <button type="submit" className="btn btn-primary px-4" onClick={this.onSend} disabled={this.state.disabled}>Send</button>
    }
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        {!window.ReactNativeWebView && (
          <ToastContainer
             position        ="top-center"
             type            ="default"
             autoClose       ={5000}
             hideProgressBar ={false}
             newestOnTop     ={false}
             closeOnClick
             pauseOnHover
           />
        )}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card-group mb-0">
                <div className="card p-4">
                  <div className="card-block text-center">
                   <h3>Forgot Password</h3>
                    <p className="text-muted">Enter your username or email below to recive your password reset instructions.</p>
                    <div className="mb-4 col-md-8 offset-md-2">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-group">
                            <input 
                              className   = "form-control" 
                              type        = "text" 
                              value       = {this.state.nick}
                              placeholder = "Enter username or email"
                              onChange    = {this.change}
                              onKeyPress  = {this.onEnter}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 d-flex">
                          <small className="case-sensitive-abs">case sensitive</small>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12">
                        {this.renderButton()}
                      </div>
                    </div>
                    {!window.ReactNativeWebView && (
                      <div className="row" style={{'position': 'absolute'}}>
                        <div className="col-md-12">
                          <button className="btn btn-link" onClick={this.gotoLogin}>
                            <i className="icon-arrow-left"></i>&nbsp;back to login
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/user/forgot.js